import React, {Fragment, useEffect, useState, useContext} from 'react';
import {Modal, ModalDialog, Button} from 'react-bootstrap';
import Scrollbar from 'perfect-scrollbar-react';
import 'perfect-scrollbar-react/dist/style.min.css';
import Logo from "../logo";
import NavItem from "../navbar/NavItem";
import socialicons from '../../data/SocialNetworks'
import gplay_icon from "../../assets/images/google_play_app.png";
import astore_icon from "../../assets/images/apple_store_app.png";
import {GlobalContext} from "../../handlers/GlobalContext";

const SideHeader = ({mobile}) => {

    const closeSideMenu = () => {
        const sideMenuWrap = document.querySelector(".side-header");
        const overlay = document.querySelector('.side-menu-overlay');
        sideMenuWrap.classList.remove('side-menu-open');
        overlay.classList.remove('overlay-show');
    };

    const isMobile = window.innerWidth < 992;
    const [show, setShow] = useState(false);
    const [ state, dispatch] = useContext(GlobalContext);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    useEffect(() => {
        const responsiveMenu = () => {
            const navWrapper = document.querySelector('.side-menu');
            const navSubMenus = navWrapper.querySelectorAll('.sub-menu');
            const hasSubMenuAnchors = navWrapper.querySelectorAll('.menu-item-has-children > a');

            navSubMenus.forEach((navSubMenu, index) => {
                navSubMenu.style.visibility = 'hidden';
                navSubMenu.style.opacity = 0;
                navSubMenu.style.height = 0;
            });

            hasSubMenuAnchors.forEach((hasSubMenuAnchor, index) => {
                let expandIcon = "<i class='expand menu-expand fa fa-angle-down'/>";
                hasSubMenuAnchor.innerHTML += expandIcon;

                hasSubMenuAnchor.addEventListener('click', (e) => {
                    e.preventDefault();
                    let subMenu = e.target.nextSibling;

                    if (subMenu.style.visibility === 'hidden') {
                        expandIcon = "<i class='expand menu-expand fa fa-angle-up'/>";
                        hasSubMenuAnchor.innerHTML += expandIcon;
                        subMenu.style.visibility = 'visible';
                        subMenu.style.opacity = 1;
                        subMenu.style.height = 'auto';
                        subMenu.style.marginTop = '15px';
                    } else {
                        expandIcon = "<i class='expand menu-expand fa fa-angle-down'/>";
                        hasSubMenuAnchor.innerHTML += expandIcon;
                        subMenu.style.visibility = 'hidden';
                        subMenu.style.opacity = 0;
                        subMenu.style.height = 0;
                        subMenu.style.marginTop = 0
                    }
                });
            });
        };
        responsiveMenu();
    }, []);

    return (
        <Fragment>
            <div className="side-menu-overlay" onClick={() => closeSideMenu()}/>
            <div className={`side-header ${mobile ? 'mobile-side-header' : null}`}>
                <div style={{display: 'flex', maxHeight: '100vh'}}>
                    <Scrollbar options={{suppressScrollX: true}} enable={!isMobile}>
                        <div className="side-header-inner">
                            <button className="side-header-close d-block d-lg-none"
                                    onClick={() => {
                                        closeSideMenu()
                                    }}>
                                <span/>
                            </button>
                            <div className="side-header-logo pt-120 pt-lg-80 pt-md-80 pt-sm-80 pt-xs-50">
                                <Logo sideHeader={true}/>
                            </div>

                            <div className="side-header-menu">
                                <nav id="side-menu">
                                    <ul className="side-menu">
                                        <NavItem/>
                                    </ul>
                                </nav>
                            </div>

                            <div className="side-header-footer pb-120 pb-lg-80 pb-md-80 pb-sm-80 pb-xs-50">
                                <div className="side-header-contact-info">
                                    {/*<p><a href="/">+012 345 6789</a></p>*/}
                                    <p><a href="/">info@eahp.com</a></p>
                                </div>

                                <div className="side-header-social">
                                    {socialicons.map(icon => (
                                        <a key={icon.id} href={`https://${icon.media}.com/${icon.username}`}>
                                            <i className={`fa fa-${icon.media}`}/>
                                        </a>
                                    ))}
                                </div>

                                <div className="side-header-copyright">
                                    <p>
                                        &copy; {new Date().getFullYear()} EAHP. <br/>
                                        {translate("sidebar-footer-allRightReserved","all rights reserved").toUpperCase()}. <br/>
                                        {translate("sidebar-footer-developedBy","developed by").toUpperCase()} <a href="http://www.v-cosmas.com" target="_blank" style={{textDecorationLine: 'underline'}}>V-COSMAS.AI</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Scrollbar>
                </div>
                <div className="app-overlay">
                    <a href="https://play.google.com/store/apps/details?id=com.vcosmas.eahp" target="_blank"><img src={gplay_icon} /></a>
                    <hr/>
                    <a href="https://apps.apple.com/fi/app/eahp-see-database/id1620873846" target="_blank"><img src={astore_icon} /></a>
                    {/*<div onClick={handleShow}><img src={gplay_icon} /></div>*/}
                    {/*<a href="../../data/app/eahp_V_1_0_0.apk" download="eahp_V_1_0_0.apk"></a>*/}

                    {/*<Modal show={show} onHide={handleClose}>*/}
                        {/*<Modal.Header closeButton>*/}
                            {/*<Modal.Title>Download Android Application</Modal.Title>*/}
                        {/*</Modal.Header>*/}
                        {/*<Modal.Body>*/}
                            {/*You are about to download the official EAHP-SEE Android application. Please note that the applications for smartphones are still in the development stage. Therefore, this action will download you the Beta version of the Android application that is not yet officially registered in the Google Play Store, and for which you will need to give a permission to be installed from a file.*/}
                            {/*<br/><br/>*/}
                            {/*More information for the necessary permissions can be found <a href="https://getupdraft.com/blog/enable-unknown-sources-android" target="_blank"><strong>here</strong></a>.*/}
                            {/*<br/><br/>*/}
                            {/*Are you sure that you would like to download the file?*/}
                            {/*<br/>*/}
                            {/*<div className="text-center -align-center align-content-center modal-dialog-centered"><a href="../../data/app/eahp_V_1_0_1.apk" download="eahp_V_1_0_1.apk"><img src={gplay_icon} width="200px" /></a></div>*/}

                            {/*<br/><br/>*/}
                            {/*<strong>NOTE:</strong> We are working on the issue and soon the application will be available in the official Google Play Store, as well.*/}
                        {/*</Modal.Body>*/}
                        {/*<Modal.Footer>*/}
                            {/*<Button variant="secondary" onClick={handleClose}>*/}
                                {/*Close*/}
                            {/*</Button>*/}
                        {/*</Modal.Footer>*/}
                    {/*</Modal>*/}
                </div>



            </div>
        </Fragment>
    );
};

export default SideHeader;
